import React from 'react';
import { View, Text } from 'react-native';
import colors from 'app/src/styles/colors';
import { CustomBidButton } from '../elements';

const paddleServices = [
  // {id: 5, code: 'EL', color: colors.biddingELGreen},
  {id: null, code: 'FL', color: colors.biddingFLBlue},
  {id: 1, code: 'PB', color: colors.biddingPBCyan},
  {id: 2, code: 'EF', color: colors.biddingEFTurquoise},
];

const AwardBidTo = ({ highBidDetails, awardBid }) => {
  const bidAwarded = (paddleServiceId) => {
    awardBid({
      variables: { id:  highBidDetails.id, paddleServiceId: paddleServiceId}
    })
  }

  return (
    <View
      style={{
        backgroundColor: '#fff',
        borderWidth: '1px',
        borderRadius: '5px',
        marginBottom: '5px',
        padding: '5px'
      }}
    >
      <Text
        style={{textAlign: 'center', fontSize: '16px'}}
      >
        Award Bid To:
      </Text>
      <View style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-around'}}>
        {
          paddleServices.map(paddleService => (
            <CustomBidButton
              title={paddleService.code}
              color={paddleService.color}
              onPress={() => bidAwarded(paddleService.id)}
              labelStyle={{ color: 'black' }}
              style={{
                maxWidth: '50px', marginLeft: '2.5px', marginRight: '2.5px'
              }}
            />
          ))
        }
      </View>
    </View>
  )
}

export default AwardBidTo;